import { render, staticRenderFns } from "./queueIndex.vue?vue&type=template&id=8bacbaaa&scoped=true"
import script from "./queueIndex.vue?vue&type=script&lang=js"
export * from "./queueIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bacbaaa",
  null
  
)

export default component.exports